export const baseUrl = 'https://app.fabulaa.ae/api/v1';

// export const baseUrl = 'http://165.227.94.114/api';
// export const baseUrl = 'http://fabulaa.local/api/v1';